import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';

import { ClearFilterIcon } from '@src/shared/ui/icons';
import IconButton, { type ExtendedIconButtonProps } from './IconButton';

const ClearFilterIconButton = forwardRef<HTMLButtonElement, ExtendedIconButtonProps>(
  (props, ref) => {
    const { t } = useTranslation();
    const tooltipTitle = t('common.clear_all_filters', 'Clear all filters');

    return (
      <IconButton
        ref={ref}
        {...props}
        tooltipTitle={tooltipTitle}
      >
        <ClearFilterIcon color="inherit" />
      </IconButton>
    );
  },
);

ClearFilterIconButton.displayName = 'ClearFilterIconButton';
export default ClearFilterIconButton;
